import m from "../../geodata/es2015/tanzaniaLow";
window.am4geodata_tanzaniaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/tanzaniaLow.js
// module id = null
// module chunks = 